import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import BottomNav from "./BottomNav";
import StickyCTAs from "./StickyCTAs";
import PageBackground from "../decor/PageBackground";

const PageLayout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="relative min-h-screen bg-ivory-texture flex flex-col" data-testid="page-layout">
      <PageBackground />
      <div className="relative z-10 flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-1 min-w-0 overflow-x-hidden pb-24 lg:pb-0">{children}</main>
        <Footer />
      </div>
      <BottomNav />
      <StickyCTAs />
    </div>
  );
};

export default PageLayout;
